<h2 mat-dialog-title class='text-lg'>Bypass Enabled</h2>
<mat-dialog-actions>
    <div class='flex justify-end ml-auto'>
        <button class='btn btn-secondary mr-sm' [mat-dialog-close]='true'>Dismiss</button>
    </div>
</mat-dialog-actions>